type IconType = "congrats" | "claim" | "request" | "prompt" | "complain";
interface ICase {
  type: number;
  title: string;
  icon: IconType;
  detail: string;
  color: string;
}
export const casesList: ICase[] = [
  {
    type: 0,
    title: "Petición",
    icon: "request",
    color: "#33CABB",
    detail:
      "Necesitas ayuda con algo o quieres presentar una solicitud por algún motivo general o particular.",
  },
  {
    type: 1,
    title: "Queja",
    icon: "complain",
    color: "#FFBE5D",
    detail:
      "Tuviste algún problema con alguno de nuestros servicios prestados y deseas expresarlo.",
  },
  {
    type: 2,
    title: "Reclamo",
    icon: "claim",
    color: "#E26147",
    detail:
      "Fallamos realizando algún proceso adecuadamente o necesitas una solución a un problema anterior.",
  },
  {
    type: 3,
    title: "Sugerencia",
    icon: "prompt",
    color: "#794FCF",
    detail:
      "Tienes algunas ideas respecto a como mejor algunos de nuestros servicios, te escuchamos.",
  },
  {
    type: 4,
    title: "Felicitación",
    icon: "congrats",
    color: "#DC6DB0",
    detail:
      "Estas feliz con la atención prestada, y quieres dejarnos un lindo mensaje.",
  },
];
